// extracted by mini-css-extract-plugin
module.exports = {"spreader":"spreader-module--spreader--19iRZ"};